/** Angular stores `navigationId` on each history entry created by the router. */
export function readAngularNavigationId(state: unknown): number {
  if (!state || typeof state !== 'object') {
    return 0;
  }
  const navigationId = (state as { navigationId?: unknown }).navigationId;
  return typeof navigationId === 'number' && Number.isFinite(navigationId) ? navigationId : 0;
}
